import React from 'react'
import { Text } from '../../elements/Text'
import { IJob } from './index'

interface IJobProps {
  job: IJob
}

export const Job = ({ job }: IJobProps): React.ReactElement => {
  return (
    <div className="greenhouse-listings__job">
      <a className="greenhouse-listings__job-title-link" href={job.absolute_url}>
        <p className="greenhouse-listings__job-title">
          <Text brand="default" size="body-bold">
            {job.title}
          </Text>
        </p>
      </a>
      <p className="greenhouse-listings__job-location">
        <Text brand="default" size="caption">
          {job.location.name}
        </Text>
      </p>

      <style jsx>
        {`
          .greenhouse-listings {
            &__job + &__job {
              margin-top: 1.5rem;
            }

            &__job-title {
              display: inline;
              padding-bottom: 0.25rem;

              :global(span) {
                font-size: 1.125rem;
              }
            }

            &__job-title-link {
              margin-bottom: 0.625rem;
              border-bottom: 1px solid $slate;
              color: $slate;
              text-decoration: none;
            }

            &__job-location {
              margin-top: 0.5rem;
            }
          }
        `}
      </style>
    </div>
  )
}
